module.exports = __webpack_public_path__ + "static/img/logo_blue.12fd2d93.png";